import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getIncome360payConfig({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v2/income360pay",
        method: "GET",
      });

      commit(MutationsType.SET_INCOME_360PAY, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveIncome360payConfig({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v2/income360pay",
        method: "POST",
        data,
      });

      commit(MutationsType.SET_INCOME_360PAY, response.data.data);
      commit("UPDATE_BUSINESS", { use_360pay: true }, { root: true });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleBusiness({ commit }) {
    commit(MutationsType.SET_INCOME_360PAY, null);
  },
};
